<template>
    <div class="login-wrap_out" >
      <div @click.stop class="login-wrap">
        <div class="remark">请先登录！</div>
        <el-tabs v-model="status" style="margin-bottom: 10px;" @tab-click="handleClick">
          <el-tab-pane label="账号登录" name="accountLogin"></el-tab-pane>
          <el-tab-pane label="手机号登录" name="mobileLogin"></el-tab-pane>
          <el-tab-pane label="手机号注册" name="register"></el-tab-pane>
        </el-tabs>
        <el-form class="formCls formCls_o"  label-position="left" :model="ruleForm"
                 :rules="rules" ref="ruleForm" label-width="0px">
          <template v-if="status == 'accountLogin'">
            <el-form-item prop="account">
              <el-input type="text" v-model="ruleForm.account" auto-complete="off" placeholder="用户名"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码"
                        show-password></el-input>
            </el-form-item>
          </template>
          <template v-else-if="status == 'mobileLogin'">
            <el-form-item prop="mobile">
              <el-input v-model="ruleForm.mobile" auto-complete="off" placeholder="手机号"></el-input>
            </el-form-item>
            <div style="display: flex;align-items: center;width: 100%;">
              <el-form-item prop="code" style="flex: 1;">
                <el-input v-model="ruleForm.code" auto-complete="off" placeholder="验证码"></el-input>
              </el-form-item>
              <el-button @click="getyanzhengma" type="primary" style="margin-bottom: 22px;margin-left: 10px;">{{
                  yanzhengma }}{{ yanzhengma == '获取验证码' ? '' : 's后重试' }}</el-button>
            </div>
          </template>
          <template v-else>
            <el-form-item prop="mobile">
              <el-input v-model="ruleForm.mobile" auto-complete="off" placeholder="手机号"></el-input>
            </el-form-item>
            <div style="display: flex;align-items: center;width: 100%;">
              <el-form-item prop="code" style="flex: 1;">
                <el-input v-model="ruleForm.code" auto-complete="off" placeholder="验证码"></el-input>
              </el-form-item>
              <el-button @click="getyanzhengma" type="primary" style="margin-bottom: 22px;margin-left: 10px;">{{
                  yanzhengma }}{{ yanzhengma == '获取验证码' ? '' : 's后重试' }}</el-button>
            </div>
            <el-form-item prop="pwd_r">
              <el-input v-model="ruleForm.pwd_r" placeholder="密码"></el-input>
            </el-form-item>
          </template>
          <el-form-item style="width:100%;">
            <el-button type="primary" style="width:100%;" @click="submitForm('ruleForm')" :loading="logining">{{ status
            ==
            'register' ? '注册' : '登录' }}
            </el-button>
          </el-form-item>
          <img src="" alt="">
        </el-form>

      </div>
    </div>

</template>
<script type="text/ecmascript-6">
import router,{resetRouter} from '@/router';
export default {
  name: 'login',
  data() {
    return {
      alibabaKey:null,
      activeSenconde: '1',
      activeName: 'first',
      logining: false,
      showPop: true,
      userData: null,
      isLogin: false,
      ishavaStore: false,
      swiperHeight: '0px',
      bannerList: [],
      status: 'accountLogin',
      showAnimate: false,
      yanzhengma: '获取验证码',
      timer: null,
      ruleForm: {
        account: '',
        password: '',
        mobile: '',
        code: '',
        pwd_r: ''
      },
      rules: {
        account: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        mobile: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }],
        pwd_r: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
      },

      activeTabBgColor: '#42d0fb', // 默认的背景色，与第一个标签的背景色相同
      routerList:[]
    }
  },
  computed: {
    currentTabBgColor() {
      const activeTab = this.tabs.find(tab => tab.name === this.activeName);
      return activeTab ? activeTab.activeTabBgColor : '#42d0fb'; // 如果没有找到激活的标签，则使用默认色
    },
    backgroundStyle() {
      return {
        backgroundImage: `linear-gradient(to bottom, ${this.currentTabBgColor}, ${this.currentTabBgColor})`,
      };
    },
  },

  // 里面的函数只有调用才会执行
  methods: {

    // 获取验证码
    getyanzhengma() {
      if (this.ruleForm.mobile) {
        if (this.yanzhengma == '获取验证码') {
          this.yanzhengma = 59
          this.timer = setInterval(() => {
            if (this.yanzhengma <= 0) {
              this.yanzhengma = '获取验证码'
              clearInterval(this.timer)
            } else {
              this.yanzhengma = this.yanzhengma - 1
            }
          }, 1000)
          this.$get(this.$api.sendsms, {
            mobile: this.ruleForm.mobile
          }).then(res => {
            if (res.status == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            }
          })
        }
      } else {
        this.$message.error('请输入手机号');
      }
    },




    handleClick() {
      this.ruleForm.account = ''
      this.ruleForm.password = ''
      this.ruleForm.mobile = ''
      this.ruleForm.code = ''
      this.ruleForm.pwd_r = ''
      clearInterval(this.timer)
      this.yanzhengma = '获取验证码'
      this.$refs['ruleForm'].resetFields();
      this.showAnimate = false
      var that = this
      setTimeout(function () {
        that.showAnimate = true
      }, 500)
    },

    // 账号密码登录
    toPwdLogin() {
      this.$get(this.$api.login, {
        type: 'account',
        account: this.ruleForm.account,
        password: this.ruleForm.password,
      }).then(res => {
        if (res.status == 200) {
          localStorage.setItem('logintoken_shop', res.data.token.token)
          localStorage.setItem('userdata_shop', JSON.stringify(res.data.user))
          this.$store.commit('saveShopData', res.data.shop)
          // 注册或者登录成功后
          this.$emit("loginOk");

        }
      })
        .finally(end => {
          this.logining = false
        })
    },
    // 手机号登录
    toMobileLogin() {
      this.$get(this.$api.login, {
        type: 'mobile',
        mobile: this.ruleForm.mobile,
        code: this.ruleForm.code,
      }).then(res => {
        if (res.status == 200) {
          localStorage.setItem('logintoken_shop', res.data.token.token)
          localStorage.setItem('userdata_shop', JSON.stringify(res.data.user))
          this.$store.commit('saveShopData', res.data.shop)
          // 注册或者登录成功后
          this.$emit("loginOk");

        }
      })
        .finally(end => {
          this.logining = false
        })
    },
    // 注册
    toregister() {
      this.$post(this.$api.register, {
        mobile: this.ruleForm.mobile,
        code: this.ruleForm.code,
        password: this.ruleForm.pwd_r
      }).then(res => {
        if (res.status == 200) {
          localStorage.setItem('logintoken_shop', res.data.token.token)
          localStorage.setItem('userdata_shop', JSON.stringify(res.data.user))
          // 注册或者登录成功后
          this.$emit("loginOk");

        }
      })
        .finally(end => {
          this.logining = false
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true
          if (this.status == 'accountLogin') {
            this.toPwdLogin()
          } else if (this.status == 'mobileLogin') {
            this.toMobileLogin()
          } else {
            this.toregister()
          }
        } else {
          this.logining = false
          return false
        }
      })
    },

  }
}
</script>

<style scoped>


.login-wrap_out {

}


.login-wrap {
  padding: 30px 35px 15px 35px;
  background: #fff;
  text-align: left;
  width: 350px;
}


.formCls {
  position: relative;
  opacity: 0;
  top: 50px;
  transition: all .2s;
}

.formCls_o {
  top: 0;
  opacity: 1;
}

>>>.el-carousel__button {
  background: gray;
  height: 4px;
}

>>>.el-carousel__indicator.is-active button {
  background: #ffaf36;
}

>>>.el-button--primary {
  background: #ffaf36;
  border-color: #ffaf36;
}

>>>.el-tabs__item.is-active {
  color: #ffaf36;
}

>>>.el-tabs__active-bar {
  background: #ffaf36;
}

>>>.el-tabs__item:hover {
  color: #ffaf36;
}

>>>.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  border: none;
}


>>>.custom-tabs .el-tabs__item.is-active {
  color: black;
}

>>>.custom-tabs .el-tabs__active-bar {
  background: black;
}

>>>.custom-tabs .el-tabs__item {
  color: #9fa4a3;
  font-size: 17px;
  height: 50px;
  padding-right: 50px;
  text-align: center;
  padding-left: 350px;
  font-weight: 100;
}

.custom-tabs-parent {
  display: flex;
  justify-content: center;
}

/* 确保整个 el-tabs 容器使用 Flexbox */
.custom-tabs {
  display: flex;
  flex-direction: column;
}

.all-tabs-parent {
  display: flex;
  justify-content: center;
  /* 这将使 custom-tabs 在其父元素中水平居中 */
  width: 1525px;
  background-color: #f4f7f9;
  height: 40px;
  border-radius: 25px;
  margin: 0 auto;
  color: black;
}

>>>.all-tabs .el-tabs__item.is-active {
  border: 1px solid #e2e5e5;
  color: black;
  border-radius: 40px;
  background-color: white;
  box-shadow: 1px 1px 10px 5px #e7eaec;

}

>>>.all-tabs .el-tabs__active-bar {
  background-color: #f4f7f9;

}

>>>.all-tabs .el-tabs__item {
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  color: #9da0a2;

}
.remark{
  font-size: 16px;
  font-weight: bold;
   color: #ffaf36;
}
</style>



// WEBPACK FOOTER //
// src/views/alibabaAuth/login.vue